import { IconSvgElement } from "@hugeicons/react";
import { FC, ReactNode } from "react";
import { BadgeVariant } from "shared/components";
import { IconBridge, IconSize } from "shared/components/IconBridge";
import { SVGComponentProps } from "untitledui-js-base";
import { BetaBadge } from "./BetaBadge";

interface NavLinkContent {
  size: IconSize;
  Icon?: FC<SVGComponentProps>;
  HugeIcon?: IconSvgElement;
  children: ReactNode;
  indicator?: string | number;
  strokeWidth?: number;
  isBeta?: boolean;
  isActive?: boolean;
}

export const NavLinkContent = ({
  size,
  Icon,
  HugeIcon,
  children,
  indicator,
  strokeWidth,
  isBeta,
  isActive
}: NavLinkContent) => (
  <>
    <IconBridge
      size={size}
      Icon={Icon}
      HugeIcon={HugeIcon}
      className="shrink-0"
      strokeWidth={strokeWidth}
    />
    {isBeta ? (
      <span className="flex items-center gap-2">
        {children}
        <BetaBadge
          variant={isActive ? BadgeVariant.PRIMARY : BadgeVariant.BASE}
          // PRIMARY's bg-primary-20 is the same solid color as the active row
          // background, so the pill would disappear; step it down one shade.
          className={isActive ? "!bg-primary-50" : undefined}
          // The badge lives inside the nav <a>; a tooltip would nest its
          // <button> trigger inside the link.
          toolTipMessage={null}
        />
      </span>
    ) : (
      children
    )}
    {indicator ? (
      <span className="absolute left-[4px] top-[2px] min-w-[16px] px-1 text-xxs text-center font-bold rounded text-white bg-primary-500 outline">
        {indicator}
      </span>
    ) : null}
  </>
);
